<template lang="html">

  <div v-if="!cards">
    Caricamento...
  </div>
  <div v-else-if="!cards.length">
    Si prega di impostare almeno una tipologia di tessera <a href="#/tessere">qui</a>
  </div>
  <div v-else>
    <Button
    type="primary"
    style="float: right"
    @click.native="refreshAssociates()">
      <Icon type="refresh"/>
    </Button>
    &nbsp;
    <Button
    @click.native="show_form = !!(form = newForm())"
    type="primary"
    style="float: right; margin-right: 5px">
      <Icon type="plus-round"/>
      Aggiungi
      
    </Button>
    <Button
    @click.native="printTo()"
    type="primary"
    style="float: right; margin-right: 5px">
      <Icon type="ios-printer"/>
      Stampa
    </Button>
    <Button
    @click.native="downloadTo('soci.xls')"
    type="primary"
    style="float: right; margin-right: 5px">
      <Icon type="android-download"/>
      Esporta
    </Button>
    <Select v-model="filters.enabled" style="width: 10rem">
      <Option :value="''">Tutti</Option>
      <Option :value="1">Tesserati</Option>
      <Option :value="0">Non rinnovati</Option>
      <Option :value="2">Richieste registrazione rapida</Option>
    </Select>
    &nbsp;
    <Input style="width: 8rem" v-model="filters.search" autofocus type="text" placeholder="Ricerca..."/>
    &nbsp;
    <Input style="width: 8rem" v-model="filters.num_ss" type="text" placeholder="Numero tessera"/>

    <div v-if="[0, 1].includes(filters.enabled)" style="margin: .5rem ">
      Anno di riferimento:
      <br>
      <Select v-model="filters.enabled_date" clearable placeholder="Attuale">
        <Option v-for="year in yearsArray()" :value="`${year}-12-01`">
          {{ year }}
        </Option>
      </Select>
    </div>

    <div style="margin: 2em 0">
      
      <CheckboxGroup v-model="show">
        <Checkbox label="birth_date">
            <span>Data nascita</span>
        </Checkbox>
        <Checkbox label="tel">
            <span>Tel.</span>
        </Checkbox>
        <Checkbox label="tel2">
            <span>Tel. 2</span>
        </Checkbox>
        <Checkbox label="email">
            <span>Email</span>
        </Checkbox>
        <Checkbox label="cf">
            <span>Codice fiscale</span>
        </Checkbox>
        <Checkbox label="stato">
            <span>Stato iscrizione</span>
        </Checkbox>
        <Checkbox label="iscritto">
            <span>Data iscrizione</span>
        </Checkbox>
        <Checkbox label="scadenza">
            <span>Data scadenza</span>
        </Checkbox>
        <Checkbox label="city">
            <span>Città</span>
        </Checkbox>
        <Checkbox label="street">
            <span>Via</span>
        </Checkbox>
      </CheckboxGroup>
    </div>
    <div style="margin: 10px;overflow: hidden" v-if="associates && associates.length > page_size">
      <Page :total="associates.length" :page-size="page_size" :current="page+1" @on-change="changePage"></Page>
    </div>
    <div  style="margin: 1em 0">
      <!-- <Table :columns="cols" :data="current_data" :loading="loading" stripe/> -->

      <div class="ivu-table spaced soci-table" style="margin: 1em 0; ;" :loading="loading">
        <table>
          <thead>
            <tr>
              <th v-for="col in cols" :key="col.id"
              @click="col.sortable && toggleSort(col)" :class="{sortable: col.sortable}" :col="col.key">
                {{ col.title }}
                <Icon v-if="sort_by.key == col.key" :type="'ios-arrow-'+(sort_by.asc?'down':'up')"/>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="ass in current_data" :key="ass.id">
              <td v-for="col in cols" :key="col.id">
                <template v-if="col.key == 'subscribed'">
                  <span :class="ass.subscription ? 'entrate' : 'uscite'">
                    {{ ass.subscription ? 'Tessera '+ass.subscription.number : '-' }}
                  </span>
                </template>
                <div v-if="col.key == 'action'" class="azioni-socio">
                  <Button type="success" size="small" @click="renew_associate = ass">
                    Tessere <Icon type="refresh"/>
                  </Button>
                  <Button type="info" size="small" @click="visualizza(ass)">
                    <Icon type="ios-eye"/>
                  </Button>
                  <Button type="info" size="small" @click="show_form = !!(form = _.clone(ass))">
                    <Icon type="edit"/>
                  </Button>
                  <Button v-if="user.is_admin" type="error" size="small" @click="delAssociate(ass)">
                    <Icon type="trash-a"/>
                  </Button>
                </div>
                <template v-else>
                  {{ col.map_fn ? col.map_fn(ass) : ass[col.key] }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div style="margin: 10px;overflow: hidden" v-if="associates && associates.length > page_size">
      <Page :total="associates.length" :page-size="page_size" :current="page+1" @on-change="changePage"></Page>
    </div>


    <Modal
    :mask-closable="false"
    :transfer="true"
    v-model="show_form"
    class-name="large"
    :title="(form && form.id ? 'Modifica' : 'Nuovo') + ' socio'">
      <SocioForm ref="associate_form" v-if="form" :form="form"/>
      <div slot="footer">
        <Button type="error" @click.native="show_form=false">
          Annulla
        </Button>
        <Button type="primary" @click.native="post(form)">
          Salva
        </Button>
      </div>
    </Modal>

    <Modal v-model="show_details_modal">
      <div v-if="show_details">
        Numero: <b>{{ show_details.number || '-' }}</b><br>
        Nome: <b>{{ show_details.first_name || '-' }}</b><br>
        Cognome: <b>{{ show_details.last_name || '-' }}</b><br>
        Codice fiscale: <b>{{ show_details.cf || '-' }}</b><br>
        Documento: <b>{{ show_details.doc || '-' }}</b><br>
        Data di nascita: <b>{{ !show_details.birth_date ? '-' : $d(Date.maintain(show_details.birth_date)) }}</b><br>
        Luogo di nascita: <b>{{ show_details.birth_city || '-' }} {{ show_details.birth_prov || '-' }}</b><br>
        Email: <b>{{ show_details.email || '-' }}</b><br>
        Telefono: <b>{{ show_details.telephone || '-' }}</b><br>
        Secondo telefono: <b>{{ show_details.second_phone || '-' }}</b><br>
        Indirizzo: <b>{{ show_details.addr_street || '-' }}</b><br>
        Città: <b>{{ show_details.addr_city || '-' }} {{ show_details.addr_prov || '-' }}</b><br>
        CAP: <b>{{ show_details.addr_zip || '-' }}</b><br>
        <div v-if="_.size(show_details.meta)">
          <br>
          <h3>Campi personalizzati:</h3>
          <div class="content" style="margin-left: 2rem">

            <ul>
              <li v-for="(value, key) in show_details.meta">{{ key }}: <b>{{ value }}</b></li>
            </ul>
          </div>
        </div>

        <div v-if="show_details.notes">
          <br>
          <h3>Note:</h3>
          <pre style="white-space: pre;">{{ show_details.notes || '-' }}</pre><br>
        </div>

        <div v-if="$store.company.can_sign || show_details.signature">
          <br>
          <h3>Firma digitale:</h3>
          <br>
          <img ref="signature_see" style="width: 100%; border: 1px solid #555">
        </div>
      </div>
      <div slot="footer">
        <Button type="error" @click.native="show_details_modal=false">
          Chiudi
        </Button>
      </div>
    </Modal>

    <RenewModal v-model="renew_associate" @refresh="refreshAssociates"/>

  </div>
</template>

<script>
import RenewModal from './renew-modal'
import collect from 'collect.js'
import SocioForm from './socio-form'

export default {
   store: {
    user: 'session.user',
  },
  name: 'soci-list',

  components: {
    RenewModal,
    SocioForm,
  },

  data() {
    return {
      page: 0,
      page_size: 100,
      cards: null,
      show_details_modal: false,
      show_details: true,
      renew_associate: false,
      console,
      loading: true,
      filters: {
        enabled: 1,
        search: '',
        enabled_date: null,
      },
      form: null,
      show_form: false,
      associates: null,
      show: [
        'iscritto',
        'stato'
      ],
      sort_by: {
        key: 'number',
        asc: true,
      },
    }
  },

  mounted() {
    this.refreshAssociates()

    this.$http.get('associate-cards?company_id='+this.$store.company.id).then(res => {
      this.cards = res.data
    })
  },

  methods: {
    newForm() {
      return {
        number: undefined,//this.$http.get('last-associate-id/'+this.$store.company.id),
        first_name: undefined,
        last_name: undefined,
        cf: undefined,
        doc: undefined,
        addr_street: undefined,
        addr_city: undefined,
        addr_zip: undefined,
        addr_prov: undefined,
        birth_date: undefined,
        birth_city: undefined,
        birth_prov: undefined,
        email: undefined,
        pec: undefined,
        telephone: undefined,
        second_phone: undefined,
        notes: undefined,
        meta: {},
        company_id: this.$store.company.id,
      }
    },
    toggleSort (col) {
      if (this.sort_by.key == col.key) {
        this.sort_by.asc = !this.sort_by.asc
      } else {
        this.sort_by = {
          key: col.key,
          asc: true,
        }
      }
    },
    visualizza (ass) {
      this.show_details = ass
      this.show_details_modal = true

      if (!this.show_details.signature) return

      setTimeout(() => {
        this.$refs.signature_see.src = ''
        this.$http.get(`signatures/${this.show_details.signature}`).then(res => {
          if (!this.show_details) return
          // console.log(this.$refs.signature_see.src, res.data)
          res.data && (this.$refs.signature_see.src = res.data)
        })
      }, 10)
    },
    changePage (page) {
      this.page = page-1
    },
    refreshAssociates(page) {
      var params = Object.assign({
        company_id: this.$store.company.id,
        page: page || 1,
      }, this.filters)

      if (this._download) {
        this.$utils.download(this._download, 'associates', params)
        this._download = null
        return
      }
      if (this._print) {
        this.$utils.print('associates', Object.assign({
          _export_ids: this.all_current_data.map(x => x.id)
        }, params))
        this._print = null
        return
      }

      this.loading = true
      this.$http.get('associates', { params }).then(
        res => {
          this.associates = res.data
        this.page = 0
        this.associates.forEach(ass => {
          if (ass.number == ass.number*1) ass.number*=1
        })
        }
        
        ).finally(() => {
        this.loading = false
      })
    },
    downloadTo(filename) {
      this._download = filename
      this.refreshAssociates()

      
    },
    yearsArray()
    {
        this.tot_years = (new Date).getFullYear()-2017
        console.log(this.tot_years)
        this.array_y = []
        for (let i = 0; i < this.tot_years; i++) {
            this.array_y.push((new Date).getFullYear()-i)
        } 
        return this.array_y
    },
    printTo() {
      console.log('print')
      this._print = 1
      this.refreshAssociates()
    },
    post(data) {
      this.$http.post('associates', data).then(res => {
        this.show_form = false
        if (!res.data.subscription) this.renew_associate = res.data
        this.refreshAssociates()
      },err => {
          
          if(err.status==409)
          {
             data.flag = confirm("L'utente "+data.first_name+" "+data.last_name+" è già presente nel libro soci.\n Vuoi aggiornare il socio già esistente con queste nuove informazioni?")
             if(data.flag)
             {
               this.$http.post('associates', data).then(res => {
               this.show_form = false
               if (!res.data.subscription) this.renew_associate = res.data
               this.refreshAssociates()
               })
             }
             //console.log(data.flag)
          }
        })
    },
    delAssociate(a) {
        confirm('Sicuri?') && this.$http.delete('associates/'+a.id).then(() => this.refreshAssociates())
    }
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.refreshAssociates()
      }, 300)
    },
  },

  computed: {
    all_current_data () {
      console.log('recalc data')
      console.log(typeof this.associates)
      let ass = this.associates || []
      ass = collect(ass)
      let sb = this.sort_by
      let col = this.cols.find(x => x.key == sb.key)
      ass = ass[sb.asc ? 'sortBy' : 'sortByDesc'](col.order_fn || (ass => {
        return String(ass[col.key] || '').toLocaleLowerCase().trim()
      })).toArray()
      console.log('recalc data end')
      return ass
    },
    current_data () {
      return this.all_current_data.slice(this.page*this.page_size, (this.page+1)*this.page_size)
    },
    cols () {
      var cols = []
      cols.push({
        title: 'ID',
        key: 'number',
        width: 100,
        sortable: true,
        order_fn: ass => ass.number*1,
        // fixed: 'left',
      })
      cols.push({
        title: 'Nome',
        key: 'first_name',
        sortable: true,
        // fixed: 'left',
      })
      cols.push({
        title: 'Cognome',
        key: 'last_name',
        sortable: true,
        // fixed: 'left',
      })
      if (this.show.includes('birth_date')) cols.push({
        title: 'Data nascita',
        key: 'birth_date',
        sortable: true,
        map_fn: ass => ass.birth_date ? this.$d(Date.maintain(ass.birth_date)) : '',
      })
      if (this.show.includes('tel')) cols.push({
        title: 'Telefono',
        key: 'telephone',
        sortable: true,
      })
      if (this.show.includes('tel2')) cols.push({
        title: 'Telefono 2',
        key: 'second_phone',
        sortable: true,
      })
      if (this.show.includes('email')) cols.push({
        title: 'Email',
        key: 'email',
        sortable: true,
      })
      if (this.show.includes('cf')) cols.push({
        title: 'Codice fiscale',
        key: 'cf',
        sortable: true,
      })
      if (this.show.includes('stato')) cols.push({
        title: 'Stato',
        key: 'subscribed',
        sortable: true,
        fn: ass => (ass.subscription || {}).number,
        order_fn: ass => (ass.subscription || {}).number*1,
      })
      if (this.show.includes('iscritto')) cols.push({
        title: 'Iscritto dal',
        key: 'subscription.date_start',
        sortable: true,
        map_fn: ass => ass.subscription ? this.$d(Date.maintain(ass.subscription.date_start)) : '',
        order_fn: ass => (ass.subscription || {}).date_start,
      })
      if (this.show.includes('scadenza')) cols.push({
        title: 'Scadenza',
        key: 'subscription.date_end',
        sortable: true,
        map_fn: ass => ass.subscription ? this.$d(Date.maintain(ass.subscription.date_end)) : '',
        order_fn: ass => (ass.subscription || {}).date_end,
      })
      if (this.show.includes('city')) cols.push({
        title: 'Città',
        key: 'addr_city',
        sortable: true,
      })
      if (this.show.includes('street')) cols.push({
        title: 'Via',
        key: 'addr_street',
        sortable: true,
      })

      let acts = null
      cols.push({
        width: 210,
        title: 'Azioni',
        key: 'action',
        align: 'center',
      })

      return cols
    }
  }
}
</script>

<style lang="scss">
.nolabelmargin {
  .ivu-form-item-content {
    margin-left: 0!important;
  }
}
.soci-table {
  th.sortable {
    cursor: pointer;
  }
  &[loading] {
    opacity: .4;
  }
  .azioni-socio {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    button {
      margin-right: 2px;
      border-radius: 3px;
    }
  }

  th[col=action] {
    width: 0;
  }
}
</style>
